export default __webpack_public_path__ + "static/media/small_business-background.557951cd.svg";